var _circle, _path, _path2, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLicenseExpirationSummer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 419,
    height: 315,
    viewBox: "0 0 419 315",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 161.5,
    cy: 248.5,
    r: 64.5,
    fill: "#F1F3F9",
    stroke: "#DADEEB",
    strokeWidth: 2.32335
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108 182L160.785 171.363C160.936 171.333 161.09 171.317 161.244 171.317H242.91C244.193 171.317 245.234 172.358 245.234 173.641V284C245.234 285.283 244.193 286.323 242.91 286.323H79.1137C77.8306 286.323 76.7904 285.283 76.7904 284L76.7904 188.512C76.7904 187.357 77.6389 186.378 78.7822 186.213L108 182Z",
    fill: "white",
    stroke: "#DADEEB",
    strokeWidth: 2.32335
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176.333 171.342C176.444 171.326 176.556 171.317 176.669 171.317H242.91C244.193 171.317 245.234 172.358 245.234 173.641V184.096H89L176.333 171.342Z",
    fill: "#F1F3F9",
    stroke: "#DADEEB",
    strokeWidth: 2.32335
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.407,
    cy: 214.88,
    r: 2.90419,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.778,
    cy: 214.88,
    r: 2.90419,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.599,
    cy: 218.365,
    r: 1.74251,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.97,
    cy: 217.204,
    r: 1.74251,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.245,
    cy: 221.269,
    r: 2.32335,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.455,
    cy: 221.269,
    r: 2.32335,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.6168,
    cy: 93.1168,
    r: 11.6168,
    fill: "#F1F3F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151 247C155.5 251.5 162 253.5 171.5 249",
    stroke: "#9FA8BA",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158 219.123C158 230.377 149.046 239.5 138 239.5C126.954 239.5 118 230.377 118 219.123C118 207.869 126.954 203.5 138 203.5C149.046 203.5 158 207.869 158 219.123Z",
    fill: "#9FA8BA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M205 219.123C205 230.377 196.046 239.5 185 239.5C173.954 239.5 165 230.377 165 219.123C165 207.869 173.954 203.5 185 203.5C196.046 203.5 205 207.869 205 219.123Z",
    fill: "#9FA8BA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M153.5 217.5H169.5",
    stroke: "#9FA8BA",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125 226C123.5 224 123.5 221 123.5 221M139.5 209.5C135 208.5 128 210.5 126.5 212.5",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M172 226C170.5 224 170.5 221 170.5 221M186.5 209.5C182 208.5 175 210.5 173.5 212.5",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M176.907 172.179C176.601 165.169 174.832 158.301 171.713 152.014C168.595 145.728 164.197 140.164 158.801 135.678C153.405 131.193 147.13 127.885 140.38 125.969C133.63 124.052 126.554 123.568 119.606 124.548C112.658 125.527 105.991 127.95 100.035 131.659C94.0783 135.368 88.9633 140.281 85.0183 146.084C81.0732 151.887 78.3854 158.451 77.1274 165.354C75.8695 172.257 76.0691 179.347 77.7136 186.169L126.325 178.191L176.907 172.179Z",
    fill: "#B2D1C7",
    stroke: "#56957F",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5001 188.5V212.5C67.6667 213.167 49.7001 212.5 48.5001 204.5C47.3001 196.5 66.6667 190.5 76.5001 188.5Z",
    fill: "#9FA8BA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M137.366 170.566C137.055 168.356 137.183 166.105 137.742 163.944C138.301 161.783 139.28 159.753 140.624 157.97C141.967 156.187 143.649 154.686 145.572 153.553C147.496 152.42 149.624 151.677 151.835 151.366C154.045 151.055 156.296 151.183 158.457 151.742C160.618 152.301 162.648 153.28 164.431 154.624C166.214 155.967 167.715 157.649 168.848 159.572C169.981 161.496 170.724 163.624 171.035 165.835L154.201 168.201L137.366 170.566Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M178.5 170C168 180 60.0262 177.948 49.5 199C43.5 211 65.5 214.667 76 211V187",
    stroke: "#9FA8BA",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.617,
    cy: 226.617,
    r: 11.6168,
    fill: "#F1F3F8"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.617,
    cy: 16.6168,
    r: 11.6168,
    fill: "#F1F3F8"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 88.5,
    r: 4.5,
    fill: "#F1F3F8"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 253.5,
    cy: 127.5,
    r: 4.5,
    fill: "#F1F3F8"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 270.5,
    r: 4.5,
    fill: "#F1F3F8"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.5,
    cy: 76,
    r: 38,
    stroke: "#DADEEB",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M337.5 30L343.5 0L349.5 30H337.5Z",
    fill: "#DADEEB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M349.5 121L343.5 151L337.5 121L349.5 121Z",
    fill: "#DADEEB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M361.054 33.0958L381.25 10.1151L371.446 39.0958L361.054 33.0958Z",
    fill: "#DADEEB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M325.946 117.904L305.75 140.885L315.554 111.904L325.946 117.904Z",
    fill: "#DADEEB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M389 69.5L419 75.5L389 81.5L389 69.5Z",
    fill: "#DADEEB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M298 81.5L268 75.5L298 69.5L298 81.5Z",
    fill: "#DADEEB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M385.904 93.0538L408.885 113.25L379.904 103.446L385.904 93.0538Z",
    fill: "#DADEEB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M301.096 57.9461L278.115 37.75L307.096 47.5538L301.096 57.9461Z",
    fill: "#DADEEB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M371.446 111.904L381.25 140.885L361.054 117.904L371.446 111.904Z",
    fill: "#DADEEB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M315.554 39.0958L305.75 10.1151L325.946 33.0958L315.554 39.0958Z",
    fill: "#DADEEB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M379.904 47.5538L408.885 37.75L385.904 57.9461L379.904 47.5538Z",
    fill: "#DADEEB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M307.096 103.446L278.115 113.25L301.096 93.0538L307.096 103.446Z",
    fill: "#DADEEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseExpirationSummer);
export default __webpack_public_path__ + "static/media/license_expiration_summer.139bca7f212fa7adbd609d1ab752ecb6.svg";
export { ForwardRef as ReactComponent };